export default __webpack_public_path__ + "static/media/info.1d0024f4.svg";